/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Health_Nav_NameInputs */

const en_service_health_nav_name = /** @type {(inputs: Service_Health_Nav_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Health Navigation Platform`)
};

const fr_service_health_nav_name = /** @type {(inputs: Service_Health_Nav_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plateforme de navigation en santé`)
};

/**
* | output |
* | --- |
* | "Health Navigation Platform" |
*
* @param {Service_Health_Nav_NameInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_health_nav_name = /** @type {((inputs?: Service_Health_Nav_NameInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Health_Nav_NameInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_health_nav_name(inputs)
	return fr_service_health_nav_name(inputs)
});